import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';

interface LanguageState {
  language: string;
  direction: 'ltr' | 'rtl';
}

const initialState: LanguageState = {
  language: 'fr',
  direction: 'ltr',
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
      state.direction = action.payload === 'ar' ? 'rtl' : 'ltr';
      i18n.changeLanguage(action.payload); 
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
